import { Button } from "@mantine/core";

import { type BodyPart } from "./BodyPart.model";

interface Props {
  type: string;
  selectedParts: BodyPart[];
  setSelectedParts: (selectedParts: BodyPart[]) => void;
}

const BodyPartModalClear = ({
  type,
  setSelectedParts,
  selectedParts,
}: Props) => {
  const handleClear = () => {
    const filteredParts = selectedParts.filter(part => part.type !== type);
    setSelectedParts(filteredParts);
  };
  const length = selectedParts.filter(part => part.type === type).length;
  if (length === 0) return null;
  return (
    <Button onClick={handleClear} variant="outline" color="red" size="xs">
      Clear
    </Button>
  );
};
export default BodyPartModalClear;
